export default function CopyDesignIcon() {
  return (
    <svg viewBox="0 0 14.07 17.91" xmlns="https://www.w3.org/2000/svg">
      <path d="M10.88 17.91H4.1a.54.54 0 0 1-.22 0H3.8a.72.72 0 0 1-.15-.11L.19 14.26a.64.64 0 0 1-.19-.45V3.2a.64.64 0 0 1 .64-.64h10.24a.64.64 0 0 1 .63.64v14.07a.63.63 0 0 1-.63.64zM1.44 4v8.84h2.84a.8.8 0 0 1 .8.8v2.84h5V4zm.64 10.11l1.72 1.73v-1.73zm11.83 1.24H12.8a.16.16 0 0 1-.16-.16V1.44H2.72a.16.16 0 0 1-.16-.16V.16A.16.16 0 0 1 2.72 0h10.71a.64.64 0 0 1 .64.64v14.55a.16.16 0 0 1-.16.16z" />
    </svg>
  );
}
